<template>
    <div class="p-0">
        <div class="font-color-171717">
    
    
            <div style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="12">
                            <h3 class="custom-40px-500 text-center mt-3">Video List</h3></CCol>
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="10">
                                    <CInput type="text" placeholder="Search..." v-model="searchQuery" />
                                </CCol>
                                <CCol sm="2" style="margin-top:-30px;">
                                    <label for="itemsPerPage" class="p-0">Items per page:</label>
                    <select v-model="itemsPerPage" id="itemsPerPage" class="form-control">
                      <option value="10">Show 10</option>
                      <option value="20">Show 20</option>
                      <option value="50">Show 50</option>
                    </select>
                                </CCol>
    
                            </CRow>
                            <CAlert show color="success">Video playback supported on all devices except ios & ipad os</CAlert>
                            <template v-if="Busy == true">
                            <div class="container text-center">
                              <pulse-loader
                                :loading="loading"
                                :color="color"
                                :size="size"
                              ></pulse-loader>
                            </div>
</template>
<CDataTable hover class="table-align-middle mb-0 font-color-171717" :items="filteredList" :fields="fields" :items-per-page="itemsPerPage" :pagination="true">
    <template #CandidateName="{ item }">
                    <td> <img v-if="item.profilePhoto !== '' && item.profilePhoto !== null" :src="item.profilePhoto" width="30px" height="30px" style="border-radius: 50%; border: 1px solid #fff; object-fit: cover;" />
                      <img v-else src="../assets/img/2-2.png" width="30px" height="30px" style="border-radius: 50%; border: 1px solid #fff; object-fit: cover;" />
                      <label class="custom-12px-500 ml-2"><label v-if="item.candidateDetail != 'undefined'">  {{ item.candidateDetail }} </label>({{ item.candidateName }})</label>
                      <br />
                
                    </td>
                  </template>
                  <template #Type="{ item }">
                    <td>
                      {{ item.type }}
                    </td>
                  </template>
                  <template #Role="{ item }">
                    <td>
                       {{ item.role }}
                    </td>
                  </template>
                  <template #Date="{ item }">
                    <td>
                       {{ item.date | moment("DD/MM/YYYY")}}
                    </td>
                  </template>
                  <template #Status="{ item }">
                    <td>
                        <span v-if="item.status ==='On Review'" class="custom-warning">   {{ item.status }}</span>
                        <span v-else-if="item.status ==='Reviewed'" class="custom-success">   {{ item.status }}</span>
                        <span v-else-if="item.status ==='Accepted'" class="custom-success">   {{ item.status }}</span>
                        <span v-else-if="item.status ==='Rejected'" class="custom-danger">   {{ item.status }}</span>
                        <span v-else class="custom-warning">   {{ item.status }}</span>
                    
                    </td>
                  </template>
                  <template #Action="{ item }">
                    <td>
                      
                        <label class="custom-border-purple text-white" @click="openVideoPopup(item.sessionId)"><label class="mr-4 ml-4 mt-2">Detail</label></label>
                        <img src="../assets/img/delete.png" @click="OpenDelete(item)" style="max-width:30px" class="ml-2">
                    </td>
                  </template>       
</CDataTable>
                         
                        </CCol>
    
                    </CRow>
                </CCard>
                <br /><br /><br />
            </div>
    
           
            <div v-if="ispopupVisible2" class="popup-all backdrop-all">
                <div class="popup-all2">
    
                    <CRow>
                        <CCol sm="11"><label class="custom-20px-600 font-color-171717">Details</label></CCol>
                        <CCol sm="1"> <img src="../assets/img/close.png" style="max-width:50px;text-align:right" @click="closePopup1" /></CCol>
                    </CRow>
                    <div class="custom-scroll">
                        <CCard class="p-20 font-color-171717 m-2">
                            <CRow class="m-2 p-20">
                                <CCol sm="12">
                                    <iframe :src="questionVideo.Url" frameborder="0" allowfullscreen style="width: 100%;height:450px"></iframe>
                                    <CRow>
                            <CCol sm="6"> <label class="ml-2 mr-2 mt-2">Current Video Question :{{ questionVideo.IndexNo }}</label></CCol> 
                        <CCol sm="6">                       <span class="custom-border-purple p-2 text-center text-white" @click="nextQuestion(questionVideo.IndexNo, questionVideo.SessionId)">
                         <label class="ml-2 mr-2 mt-2">Next Video</label></span></CCol>
                        </CRow>
                         <h4 class="mt-2">Question:</h4>
                         <p>{{ questionVideo.Question }}</p>
                         <h4 class="mt-3">Answer:</h4>
                         <!-- <p>{{ questionVideo.Answer }}</p> -->
                         <p class="custom-12px-400" v-html="formattedAnswer"></p>
                         <h4 class="mt-3">Uploaded Files:</h4>
                                            <ul class="file-list">
                                                <li v-for="(file, index) in doc" :key="index">
                                                    <div class="file-info">
                                                    <img src="../assets/img/iconfile.png" width="40px" class="file-icon" />
                                                    <span class="file-name ml-3"><a :href="file.Url" target="_blank">{{ file.FileName }}</a></span>
                                                    </div>
                                                </li>
                                            </ul>
                                </CCol>
                                <CRow id="printsection">
                                <CCol sm="5" class="p-0">
    
                                    <h3 class="custom-18px-500 font-inter mt-2">
                                        4 personal character indicators
                                    </h3>
    
                                    <CCard>
                                        <CRow>
                                            <CCol v-if="report === 'Not available yet.'" sm="6">
                                                <CRow class="text-center m-0">
                                                    <CChartDoughnut :datasets="defaultDatasets" />
                                                    <br />
                                                    <span class="text-center ml-2">No data available.</span>
                                                </CRow>
    
                                            </CCol>
    
                                            <CCol v-else sm="6" v-for="(dataset, index) in datasets" :key="index">
                                                <div class="text-center">
                                                    <CChartDoughnut :datasets="[dataset]" :labels="[dataset.label]" :options="chartOptions"/>
              
                                                </div>
                                            </CCol>
    
    
    
                                        </CRow>
                                        <br />
                                    </CCard>
    
                                    <CCard>
                                        <h3 class="custom-14px-400 font-inter m-2">Overall performance</h3>
                                        <CChartRadar
      ref="radarChart"
      :datasets="radarChartData.datasetsRadar"
      :options="defaultOptionsRadar"
      :labels="radarChartData.labels"
    />
    <br />
                                    </CCard>
    
    
    
    
                                </CCol>
                                <CCol sm="7" class="p-0">
    
                                    <CCol sm="12">
    
    
                                        <h3 class="custom-18px-500 font-inter mt-2">Detail Explanation & Score</h3>
                                        <h3 class="custom-14px-400 font-inter">Ranked based on users answer</h3>
                                        <CCard>
    
                                            <CRow class="m-2">
                                                <CCol v-if="report === 'Not available yet.'" sm="6">
                                                    <p>No data available.</p>
                                                </CCol>
                                                <CCol v-else sm="6" v-for="(trait, index) in report" :key="index">
                                                    <div>
                                                        
                                                        <CRow class="mt-2">
                                                            <CCol sm="8">                          <h4 class="custom-18px-600 font-color-171717 font-inter font-small">{{ trait.Type }}</h4></CCol>
                                                            <CCol sm="4">                             <h4 class="custom-16px-500 font-color-171717 font-inter">{{ trait.Value }} /10</h4></CCol>
                                                            
                                                            <CCol sm="12">
                                                                <p class="custom-14px-400 mt-2 font-color-171717">{{ trait.Details }}</p>
                                                            </CCol>
                                                            <CCol sm="12">
                                                                <!-- <progress :value="trait.Value" max="10" show-percentage style="width:100%"></progress> -->
                                                                <CProgress :value="trait.Value" show-percentage color="success" max="10" :animated="animate" class="mb-2" />
                                                            </CCol>
                                                        </CRow>
                                                    </div>
                                                </CCol>
                                            </CRow>
    
                                        </CCard>
    
    
                                    </CCol>
                                </CCol>
                            
                                <CCol sm="12" class="mt-3">
                                    <h3 class="custom-16px-600">Summary</h3>
                                    <h4 class="custom-18px-400" v-if="reportSummary != null">  <pre>{{ reportSummary }}</pre></h4>
                                </CCol>
                                </CRow>
                                <CCol sm="12">
                                    <h3 class="custom-16px-600">Status</h3>
                                    <v-select v-model="selectedStatus" :options="statusOptions" label="Name"></v-select>
                                    <label class="custom-border-purple text-white mt-3" @click="UpdateStatusInterview(questionVideo.SessionId, selectedStatus.Name)"><label class="mr-4 ml-4 mt-2">Submit Status</label></label>
                                    </CCol>
                                <CCol sm="6"> <label class="custom-border-purple-white p-2 mr-2 font-color-928AFD text-center mt-5 mb-5" style="width:100%" v-on:click="PrintSectionInvoice"><img style="width:20px" src="../assets/img/Download.png"/>Download</label></CCol>
                                <CCol sm="6"> <label class="custom-border-purple p-2 mr-2 text-white text-center mt-5 mb-5" style="width:100%">Continue</label></CCol>
    
                            </CRow>
                        </CCard>
                    </div>
                </div>
            </div>

            <div v-if="ispopupVisible3" class="popup-all backdrop-all">
                <div class="popup-all2">
                    <CRow>
                        <CCol sm="11"><label class="custom-20px-600 font-color-171717">Rate Your Candidate</label></CCol>
                        <CCol sm="1">  <img src="../assets/img/close.png" style="max-width:50px;text-align:right" @click="closePopup2" /></CCol>
                    </CRow>
                  
                                <div class="custom-scroll">
                                    <CCard class="p-2">
                                        <label class="custom-14px-400">Your Rate</label>
                                        <CInput type="text" />

                                        <label class="custom-14px-400">Title</label>
                                        <CInput type="text" />

                                        <label class="custom-14px-400">Description</label>
                                        <tinymce
                    id="d1"
                    v-model="Content"
                    placeholder="Enter Your Content"
                    class="mb-2"
                  ></tinymce>
                  <label class="custom-14px-400">Review By</label>
                                        <CSelect></CSelect>
                                        <div class="text-center">
                                            <label class="custom-border-purple p-2 mr-5 text-white">Submit</label>
                                        </div>
                                       
                                    </CCard>
                                   
                                </div>
                     
    
    
                </div>
            </div>

            <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Successfully Save
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px">
                        <span class="ml-2 mr-2">OK</span>
                    </CButton>
                </div>
            </div>
        </div>


        <div v-if="isPopupDelete" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 100px" src="../assets/img/Ellipsedelete.png" />
                        <h3 class="custom-18px text-center mt-3">
                            Are you sure want to delete <br /> {{ sessionTitle }} for {{ sessionCode }}?
                        </h3>
                        <div class="mt-4">
                            <label class="custom-grey-radius ml-2 font-color-171717 mr-4" @click="DeleteSession(sessionDelete)" style="width:100px">Yes</label>
                            <label class="custom-border-purple p-2 text-center mr-2 text-white" @click="CloseDelete()" style="width:100px">Cancel</label>
                        </div>
                    </div>
    
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartDoughnut } from '@coreui/vue-chartjs';
import { CCol } from '@coreui/vue';
Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");
import _ from "lodash";
import { CChartRadar } from '@coreui/vue-chartjs'
import html2pdf from 'html2pdf.js';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        PulseLoader,
        CChartDoughnut,
        CCol,
        CChartRadar,
        html2canvas,
        jsPDF
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            ispopupVisible2: false,
            ispopupVisible3: false,
            list: [],
            user: {},
            videoUrl: '',
            searchQuery: '',

            questionVideo: {},
            Busy: false,
            report: [],
            reportRadar: [],
            reportRank: [],
            reportSummary: '',
            datasets: [],
            maxScore: 10, // Maximum score possible
            max: 10,
            doc:[],
            chartOptions: {
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom', // Place legend at the bottom
                        labels: {
                            fontColor: 'black', // Adjust font color as needed
                            fontSize: 14,
                        },
                    },
                    doughnutBackgrounds: {
                        colors: [
                            { backgroundColor: 'rgba(0, 0, 0, 0.1)' }, // Example background color
                        ],
                    },
                    tooltip: {
                        enabled: true, // Enables tooltip
                        callbacks: {
                            label: function(context) {
                                // Display only value inside the tooltip
                                const value = context.raw || 0;
                                return `${value}`;
                            },
                        },
                    },
                    datalabels: {
                        display: function(context) {
                            // Show datalabels only for the value part
                            return context.dataIndex === 0;
                        },
                        formatter: function(value) {
                            return value; // Display the value
                        },
                        color: '#000', // Set text color
                        font: {
                            size: 14, // Set font size
                            weight: 'bold', // Set font weight
                        },
                    },
                },
            },
            fields: [{
            key: 'CandidateName'
          }, {
            key: 'Type'
          },
          {
            key: 'Role'
          },{
            key: 'Date'
          },
          {
            key: 'Status'
          },
          {
            key: 'Action'
          }, ],
          currentPage: 1,
          itemsPerPage: 10,
          size: "",
          color: "",
          loading: "",
          statusOptions: [],
          isPopupSuccess: false,
          selectedStatus: "",
          radarChartData: {
        labels: [],
        datasetsRadar: [{
          label: 'AI Video Score',
          backgroundColor: 'rgba(145, 138, 246, 0.25)',
          borderColor: 'rgba(113, 100, 169, 1)',
          data: [],
        }]
      },
      defaultOptionsRadar: {
        aspectRatio: 1.5,
        scales: {
          r: {
            angleLines: { display: true },
            ticks: {
              suggestedMin: 1, // Adjusted minimum value
              suggestedMax: 10,
              beginAtZero: false,
              stepSize: 2
            }
          }
        }
    },
    isPopupDelete: false,
    animate: "",
    max:10
        };
    },
    created() {},
    computed: {
        filteredList() {
            const query = (this.searchQuery || '').toLowerCase().trim(); // Ensure searchQuery is a string

            const filtered = this.list.filter(item => {
                const job = item.name || ''; // Ensure item.job is a string
                const code = item.type || ''; 
                const role = item.role || ''; 
                const matchesQuery = query ? job.toLowerCase().includes(query) || code.toLowerCase().includes(query) : true;

                return role.toLowerCase() === 'surveying' && matchesQuery;
            });

            return filtered;
        },
        defaultDatasets() {
            return [{
                backgroundColor: [

                    '#928AFD'
                ],
                data: [100]
            }]
        
    },
    totalItems() {
          return this.filteredList.length;
        },
        pagedList() {
          // Paginate the filtered list based on currentPage and itemsPerPage
          const startIndex = (this.currentPage - 1) * this.itemsPerPage;
          return this.filteredList.slice(startIndex, startIndex + this.itemsPerPage);
        },
        startIndex() {
          return (this.currentPage - 1) * this.itemsPerPage + 1;
        },
        endIndex() {
          return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
        },
        formattedAnswer() {
            // Replace the newline characters with <br> for HTML rendering
            return this.questionVideo.Answer.replace(/\n/g, '<br>');
        }
    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser(); // Fetch the user details first
                    this.getListVideo();
                    this.getListStatus();
                

            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async getListVideo() {

            try {
                this.Busy = true;
                const response = await this.$API.get(this.$ListCodeInterviewr, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    if(response.data === 'Not available')
                    {
                        this.Busy = false;
                    }
                    else
                    {
                        this.Busy = false;
                    this.list = response.data;
                    this.photoURL = this.list.profilePhoto;
                    }
                    
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },

        closePopup1() {
            this.ispopupVisible2 = false;
        },
        OpenPopup() {
            this.ispopupVisible2 = true;
        },
        OpenForm() {
            this.ispopupVisible2 = false;
            this.ispopupVisible3 = true;

        },
        closePopup2() {
            this.ispopupVisible3 = false;
        },

        openVideoPopup(sessionId) {
            //console.log("video" + url);
            // this.videoUrl = url;
            this.getReport(sessionId);
            this.getReportRadar(sessionId);
            this.getReportRank(sessionId);
            this.getReportSummaryRank(sessionId);
            this.getListQuestion(1, sessionId);
            this.getListDoc(sessionId);
            this.ispopupVisible2 = true;
        },

        // Method to close the video popup
        closeVideoPopup() {
            this.isPopupVisible3 = false;
            // Optionally, you can clear the video URL when the popup is closed
            // this.videoUrl = '';
        },
        async nextQuestion(index, sessionId) {
            this.index++;
            this.index1 = index + 1;
            this.showVideo = false;
            console.log("index" + this.index1);
            this.getListQuestion(this.index1, sessionId);

        },
        async getListQuestion(index, sessionId) {
            try {
                const response = await this.$API.get(
                    `${this.$GetNextQuestionVideo}/${sessionId}/${index}`, {
                        withCredentials: true,
                    }
                );
                if (response.status === 200) {
                    this.questionVideo = response.data;
                } else {

                }
            } catch (error) {}

        },
        async getReport(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.report = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getReportRadar(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.reportRadar = response.data;
                    this.processReportData(this.report);
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        processReportData() {
      // Extract Type and Value for labels and data
      this.radarChartData.labels = [...this.reportRadar.map(item => item.Type)];
      this.radarChartData.datasetsRadar[0].data = [...this.reportRadar.map(item => item.Value)];
    },
        async getReportRank(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    const relevantTypes = ['Attitude', 'Communication', 'Sociability', 'Teamwork'];
                    this.reportRank = response.data;
                    console.log("rank" + this.reportRank);
                    this.prepareChartData(this.reportRank);
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getReportSummaryRank(sessionId) {
            try {
                const response = await this.$API.get(this.$SessionSummary + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.reportSummary = this.reformatSummary(response.data.Summary);
                } else {
                    // Handle non-200 status code
                    this.reportSummary = null;
                }
            } catch (error) {
                // Handle the error here
                this.reportSummary = null;
            }
        },
        reformatSummary(summaryText) {
            return summaryText ? summaryText.replace(/:/g, ':\n') : null;
},
        prepareChartData() {
            const relevantCategories = ['Attitude', 'Communication', 'Sociability', 'Teamwork'];
            const maxScore = 10;

            this.datasets = this.reportRank
                .map(trait => ({
                    data: [trait.Value * 10, (maxScore - trait.Value) * 10],
                    backgroundColor: ['#928AFD', '#E0E0E0'],
                    label: trait.Type
                }));
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        async getListStatus() {
            try {
                const response = await this.$API.get(this.$ListStatus);
                if (response.status === 200) {
                    this.statusOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        UpdateStatusInterview(sessionId, status) {
            const formData = new FormData();
            formData.append("sessionId", sessionId);
            formData.append("statusType", status);
            this.$API
                .post(this.$SetStatus, formData, {
                    withCredentials: true
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status === 200) {
                        this.isPopupSuccess = true;
                        this.getListVideo();
                    } else {
                        this.Loading = false;
                        this.Error = true;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccess()
        {
            this.isPopupSuccess = false;
        },
        OpenDelete(item) {
            this.sessionDelete = item.sessionId;
            this.sessionTitle = item.candidateName;
            this.sessionCode = item.type;
            this.isPopupDelete = true;
        },
        DeleteSession: function(sessionId) {
            const formData = new FormData();

            formData.append("sessionId", sessionId);

            return this.$API
                .post(this.$DeleteVideoCodeSession, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.isPopupDelete = false;
                        this.isPopupSuccess = true;
                        this.getListVideo();
                    } else {
                        this.Busy = false;
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        CloseDelete() {
            this.isPopupDelete = false;
        },
        downloadPDF() {
        const element = document.querySelector('.popup-all2');
        html2pdf().from(element).toPdf().print();
    },
    PrintSectionInvoice() {
        const printSection = document.getElementById('printsection');
        
        html2canvas(printSection, {
            scale: 2,
            useCORS: true,
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'pt',
                format: 'a4',
            });

            const margin = 30; // Margin around the content
            const imgWidth = 595.28 - 2 * margin; // A4 width in points minus margins
            const imgHeight = (canvas.height * imgWidth) / canvas.width; // Calculate height based on width
            let heightLeft = imgHeight;
            let position = margin;

            // Add the image to the first page
            pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
            heightLeft -= (841.89 - 2 * margin); // Subtract the page height minus margins

            // Add additional pages if necessary
            while (heightLeft > 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
                heightLeft -= (841.89 - 2 * margin); // Subtract the page height minus margins
            }

            pdf.save('download.pdf');
        });
    },
    async getListDoc(sessionId) {
            try {
                const response = await this.$API.get(this.$GetDocDetails + "?sessionId=" + sessionId, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.doc = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },








    }

};
</script>

<style scoped>
.watermark {
    position: absolute;
    top: 24%;
    left: 25%;
    transform: rotate(-40deg);
    font-size: 80px;
    color: rgba(0, 0, 0, 0.1);
    /* Adjust opacity as needed */
    pointer-events: none;
    /* Make sure the watermark doesn't interfere with other elements */
    z-index: 1;
}
pre {
  white-space: pre-wrap; /* Ensures that newlines and spaces are rendered as expected */
  color: #171717;

font-family: Inter;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: 150%; /* 27px */
}
</style>
